/* global axios */
import ApiClient from './ApiClient';

class CatalogItemsApi extends ApiClient {
  constructor() {
    super('catalog_items', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export const catalogItemsApi = new CatalogItemsApi();
